// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "customer-260922-36/static/css/" + chunkId + "." + {"164":"a834d5dc","2395":"a834d5dc","2595":"9e41f036","2982":"33c84e52","4029":"9e41f036","6926":"a834d5dc","7951":"a834d5dc","8395":"9e41f036","9254":"9e41f036"}[chunkId] + ".chunk.css";
};